<template>
  <StepLayout pageId="page-1" title="Choose a Date" contentId="calendar-modal">
      <div id="dateSelect-calendar"></div>
  </StepLayout>
</template>
<script>
import StepLayout from "./StepLayout.vue";

export default {
  name: "ReservationStep1",
  components: {
    StepLayout
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ReservationStep1.vue